import { useTimeFilterContext } from 'modules/iterableGoals/contexts';
import { AnalyticsTabs } from 'modules/iterableGoals/types';
import { NoData } from '../sections';
import { CampaignsTab, OverviewTab } from './index';

type CurrentTabType = {
  selectedTab: AnalyticsTabs;
};

export const CurrentTab = ({ selectedTab }: CurrentTabType) => {
  const {
    timeParams: { timeRangeHasData },
  } = useTimeFilterContext();

  if (!timeRangeHasData) {
    return <NoData />;
  }

  switch (selectedTab) {
    case AnalyticsTabs.OVERVIEW:
      return <OverviewTab />;

    case AnalyticsTabs.CAMPAIGNS:
      return <CampaignsTab />;

    default:
      return <></>;
  }
};
